import { render } from "./OrderEntityLink.vue?vue&type=template&id=1d527b7e&scoped=true"
import script from "./OrderEntityLink.vue?vue&type=script&lang=js"
export * from "./OrderEntityLink.vue?vue&type=script&lang=js"

import "./OrderEntityLink.vue?vue&type=style&index=0&id=1d527b7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d527b7e"]])

export default __exports__